export enum StatusProcurementReportScheduleEnum {
	Recurrent = 1,
	Scheduled = 2,
	Sent = 3,
}
